import React, { useState, useEffect, useRef } from "react";
import { Prompt } from "react-router";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Switch,
  Select,
  message,
  Empty,
  Modal,
  Radio,
  Space,
  Row,
  Col,
  Menu,
  TreeSelect,
  Dropdown,
  Typography,
  Spin,
  Tag,
} from "antd";
import {
  getAccountById,
  editAccount,
  getActiveParents,
  getInitiale,
  getAccCatTreeSearch,
} from "../../services/AccountService";
import { getCurrActiveSearch } from "../../services/Items/currenciesService";
import { getActivePayMethodSearch } from "../../services/Items/payMethodService";
import { getActivePriceMethodSearch } from "../../services/Items/pricingMethodsService";
import { getTreeSearch } from "../../services/FinalAccountService";
import SelectSingle from "../helper/selectSingle";
import { ExclamationCircleOutlined, RetweetOutlined } from "@ant-design/icons";
import { shortCut } from "../helper/shortCuts";
import _t from "../../languages/translate";
import { handleEx } from "../helper/handleException";
import { getAuth } from "../../services/Authorization/userRoleService";
import { authKeys } from "../../services/Authorization/authKeys";
import SelectParentAccount from "../helper/inputSelect/selectParentAccount";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AccountForm = () => {
  const IX_Code = useRef(null);
  const IX_Name = useRef(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [mainState, setMainState] = useState(false);
  let history = useHistory();
  let { id } = useParams();
  let query = useQuery();
  //******************************//
  const [parentChange, setParentChange] = useState(false);
  const [parentOpt, setParentOpt] = useState([]);
  const [currOpt, setCurrOpt] = useState([]);
  const [payMethodOpt, setPayMethodOpt] = useState([]);
  const [priceMethodOpt, setPriceMethodOpt] = useState([]);
  const [finalAccOpt, setFinalAccOpt] = useState([]);
  const [accCatData, setAccCatData] = useState([]);
  const [isGoParentId, setIsGoParentId] = useState(null);
  const [stateParintId, setStateParintId] = useState("");
  const [isGoBack, setIsGoBack] = useState(true);
  //******************************//
  const [proChange, setProChange] = useState(false);
  const { TextArea } = Input;
  const { Text } = Typography;

  //////////----|👉 start auth|----//////////
  // perDelete
  // perExcel
  // perPdf
  // perPost
  // perPrint
  // perPut
  // perView
  //-----------------------------------------
  const [auth, setAuth] = useState({});
  const authorization = async () => {
    const obj = JSON.parse(localStorage.getItem("auth"));
    if (obj !== null) {
      const responce = obj.filter((e) => e?.roleKey === authKeys.acc)[0];
      setAuth(responce);
    } else {
      try {
        const data = await getAuth();
        localStorage.setItem("auth", JSON.stringify(data.data.data));
        authorization();
      } catch (ex) {
        return null;
      }
    }
  };
  //////////----|👉 end auth|----//////////

  const promptForm = () => {
    setProChange(true);
  };

  const initValue = async (Id) => {
    try {
      const { data: newData } = await getInitiale(Id);

      form.setFieldsValue({
        code: newData.data.code !== null ? newData.data.code : "",

        parentId:
          newData.data.parentId !== null &&
          newData.data.parentId !== "00000000-0000-0000-0000-000000000000"
            ? newData.data.parentId
            : undefined,
        accCatId:
          newData.data.accCatId !== null &&
          newData.data.accCatId !== "00000000-0000-0000-0000-000000000000"
            ? newData.data.accCatId
            : undefined,
        accFinalId:
          newData.data.accFinalId !== null &&
          newData.data.accFinalId !== "00000000-0000-0000-0000-000000000000"
            ? newData.data.accFinalId
            : undefined,
        defCurrencyId:
          newData.data.defCurrencyId !== null &&
          newData.data.defCurrencyId !== "00000000-0000-0000-0000-000000000000"
            ? newData.data.defCurrencyId
            : undefined,
        defPayMethodId:
          newData.data.defPayMethodId !== null &&
          newData.data.defPayMethodId !== "00000000-0000-0000-0000-000000000000"
            ? newData.data.defPayMethodId
            : undefined,
        defPriceMethodId:
          newData.data.defPriceMethodId !== null &&
          newData.data.defPriceMethodId !==
            "00000000-0000-0000-0000-000000000000"
            ? newData.data.defPriceMethodId
            : undefined,
        costCenterReqOpt: newData.data.costCenterReqOpt,
        inactive: newData.data.inactive,

        // isMain: newData.data.isMain,

        type: newData.data.type,
      });
      handleActiveParents(
        "",
        newData.data.parentId !== null && newData.data.parentId !== undefined
          ? newData.data.parentId
          : ""
      );
      handleCurrActiveSearch("");
      handlePriceMethod("");
      handlePayMethod("");
      handleFinalAccSearch("");
      handleAccCat("");
      IX_Name.current.focus();
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  const getById = async (Id) => {
    try {
      const { data } = await getAccountById(id);

      if (data.data.parentId === null) {
        data.data.parentId = "";
      }
      setStateParintId(data.data.parentId);
      form.setFieldsValue({
        code: data.data.code,
        isMain: data.data.isMain,
        parentId: data.data.parentId,
        name: data.data.name,
        name2: data.data.name2,
        defCurrRateValue: data.data.defCurrRateValue,
        accCatId: data.data.accCatId,
        defCurrencyId: data.data.defCurrencyId,
        defPayMethodId: data.data.defPayMethodId,
        defPriceMethodId: data.data.defPriceMethodId,
        costCenterReqOpt: data.data.costCenterReqOpt,
        accFinalId: data.data.accFinalId,
        inactive: data.data.inactive,
        note: data.data.note,
      });
      handleActiveParents(
        "",
        data.data.parentId !== null && data.data.parentId !== undefined
          ? data.data.parentId
          : ""
      );
      handleCurrActiveSearch("");
      handlePriceMethod("");
      handlePayMethod("");
      handleFinalAccSearch("");
      handleAccCat("");
      IX_Name.current.focus();
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  useEffect(() => {
    authorization();
    async function fetchData() {
      if (id === "new") {
        return await initValue("");
      } else if (id === "add") {
        const parentId = query.get("ParentId");

        //const parentId = history.location.state?.parentId;

        if (!parentId) return;
        setIsGoParentId(parentId);
        return await initValue(parentId);
      } else {
        setParentChange(true);
        return await getById(id);
      }
    }
    fetchData();
  }, []);

  const onChangeParent = async (value) => {
    if (parentChange === true) {
      Modal.confirm({
        title: `${_t("msgAskGenerateANewCode")}`,
        icon: <ExclamationCircleOutlined />,
        content: `${_t("msgGenerateANewCode")}`,
        direction: _t("langDiriction"),
        okText: `${_t("strYes")}`,
        cancelText: `${_t("strNo")}`,
        async onOk() {
          setParentChange(false);
          initValue(value);
          setProChange(true);
        },
        onCancel() {
          setProChange(true);
        },
      });
    } else {
      initValue(value);
      setIsGoParentId(value);
      setProChange(true);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsGoBack(true)}>
        {_t("strLeaveThePage")}
      </Menu.Item>
      <Menu.Item onClick={() => setIsGoBack(false)}>
        {_t("strStayInPage")}
      </Menu.Item>
    </Menu>
  );

  const goBack = () => {
    if (isGoBack) {
      if (history.action === "POP") {
        history.push({ pathname: "/account" });
      } else {
        history.goBack();
      }
    } else {
      if (id !== "new" && id !== "add") {
        history.replace({ ...history.location, pathname: "/account/new" });
      }
      form.resetFields();
      initValue(isGoParentId);
      handleActiveParents("", "");
      handleCurrActiveSearch("");
      handlePriceMethod("");
      handlePayMethod("");
      handleFinalAccSearch("");
      handleAccCat("");
      IX_Name.current.focus();
    }
  };

  const handleCurrActiveSearch = async (_Search) => {
    try {
      const { data: responce } = await getCurrActiveSearch(_Search);
      setCurrOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  const handlePayMethod = async (_Search) => {
    try {
      const { data: responce } = await getActivePayMethodSearch(_Search);
      setPayMethodOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  const handlePriceMethod = async (_Search) => {
    try {
      const { data: responce } = await getActivePriceMethodSearch(_Search);
      setPriceMethodOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  const handleFinalAccSearch = async (_Search) => {
    try {
      const { data: responce } = await getTreeSearch(_Search);
      setFinalAccOpt(responce.data);
    } catch (error) {
      handleEx(error);
    } finally {
      setLoadData(false);
    }
  };

  const handleAccCat = async (_Search) => {
    try {
      const { data: responce } = await getAccCatTreeSearch(_Search);
      setAccCatData(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  const handleActiveParents = async (_Search, _Active) => {
    try {
      const { data: responce } = await getActiveParents(_Search, _Active);
      setParentOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_Name });
    } finally {
      setLoadData(false);
    }
  };

  //******************************// //*******************// Save //*******************// //******************************//

  const onFinish = async (values) => {
    setLoadData(true);
    setProChange(false);
    values.id = id;
    if (values.isMain === undefined) {
      values.isMain = false;
    }
    if (values.startDate !== "") {
      values.startDate = values.startDate?.toISOString().slice(0, 16) + "Z";
    }
    if (values.endDate !== "") {
      values.endDate = values.endDate?.toISOString().slice(0, 16) + "Z";
    }
    try {
      const data = await editAccount(values);
      setLoadData(false);
      message.success(data.data.message, 3);
      goBack();
      form.setFieldsValue({ isMain: mainState });
    } catch (error) {
      setLoadData(false);
      handleEx(error, { IX_Code, IX_Name });
    }
  };

  const [altPress, setAltPress] = useState(false);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      const confState = JSON.parse(window.sessionStorage.getItem("confState"));
      let showModal = JSON.parse(window.sessionStorage.getItem("showModal"));
      if (showModal === false || showModal === null) {
        if (!confState) {
          switch (shortCut(e)) {
            case "save":
              form.submit();
              break;
            case "search":
              IX_Code?.current?.focus();
              IX_Code?.current?.select();
              break;
            case "block1":
              IX_Name?.current?.focus();
              break;
            case "tag":
              setAltPress(true);
              break;
            default:
              break;
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keydown", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      if (e.keyCode === 18) {
        setAltPress(false);
      }
    };
    window.addEventListener("keyup", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keyup", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      setAltPress(false);
    };
    window.addEventListener("blur", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("blur", handleKeydownOnEdit);
    };
  }, []);

  //******************************// //*******************// Form Code //*******************// //******************************//

  const parentOptList =
    parentOpt.length > 0 &&
    parentOpt.map((item) =>
      item.id !== id ? (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ) : null
    );

  const currOptList =
    currOpt.length > 0 &&
    currOpt.map((item) => (
      <Select.Option key={item.currId} value={item.currId}>
        {item.currName}
      </Select.Option>
    ));
  const payMethodOptList =
    payMethodOpt.length > 0 &&
    payMethodOpt.map((item) => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));
  const priceMethodOptList =
    priceMethodOpt.length > 0 &&
    priceMethodOpt.map((item) => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));

  const finalAccOptList =
    finalAccOpt.length > 0 &&
    finalAccOpt.map((item) => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));

  return (
    <div key="mainDiv">
      <React.Fragment>
        <Prompt when={proChange} message={_t("strUnsavedChanges")} />
        <Spin spinning={loadData} tip={_t("strLoading")}>
          <Form
            form={form}
            name="branchform"
            onFinish={onFinish}
            layout="horizontal"
            labelCol={{
              flex: "150px",
            }}
            wrapperCol={{
              span: 20,
            }}
            initialValues={{ isMain: mainState }}
          >
            <div name="code" className="frHeader">
              <Row>
                <Col xs={24} md={24}>
                  <Space split="#">
                    <Space split="\">
                      <Text>{_t("strDefinitions")}</Text>
                      <Text style={{ fontWeight: 700 }}>
                        {_t("strAccounts")}
                      </Text>
                    </Space>
                    <div>
                      <Form.Item
                        name="code"
                        rules={[
                          { required: true, message: `${_t("strIsRequired")}` },
                          { min: 1, message: `${_t("strFrom3-200")}` },
                          { max: 200, message: `${_t("strFrom3-200")}` },
                        ]}
                      >
                        <Input
                          className="inpCode"
                          size="small"
                          placeholder={_t("strCode")}
                          maxLength={200}
                          autoComplete="off"
                          onChange={promptForm}
                          ref={IX_Code}
                          bordered={false}
                        />
                      </Form.Item>
                      <div
                        style={{
                          opacity: 0.8,
                          zIndex: 99,
                          position: "absolute",
                          top: 24,
                        }}
                      >
                        <Tag color="#2b2b2b" hidden={!altPress}>
                          alt + F
                        </Tag>
                      </div>
                    </div>
                  </Space>
                </Col>
              </Row>
            </div>

            <Row gutter={3}>
              <Col flex="1 1 400px">
                <div name="field" className="frContent">
                  <Row gutter={12}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label={_t("strAccountClassification")}
                        name="isMain"
                      >
                        <Radio.Group
                          buttonStyle="solid"
                          onChange={(e) => {
                            setMainState(e.target.value);
                          }}
                        >
                          <Radio value={false} autoFocus>
                            {_t("strSub")}
                          </Radio>
                          <Radio value={true}>{_t("strMain")}</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="parentId"
                        label={_t("strMainAccount")}
                        rules={[{ required: false }]}
                      >
                        <SelectParentAccount
                          addId={form.getFieldValue("parentId")}
                          onChange={onChangeParent}
                          placeholder={_t("strNotSelected")}
                        />

                        {/* <Select
                          allowClear
                          showSearch
                          filterOption={false}
                          onSearch={(value) => {
                            handleActiveParents(value, stateParintId);
                          }}
                          optionFilterProp="children"
                          notFoundContent={
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
                          }
                          onChange={onChangeParent}
                          placeholder={_t("strNotSelected")}
                          size="small"
                        >
                          {parentOptList}
                        </Select> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="name"
                        label={
                          <div>
                            {_t("strName")}
                            <div
                              style={{
                                opacity: 0.8,
                                zIndex: 99,
                                position: "absolute",
                                top: 4,
                              }}
                            >
                              <Tag color="#2b2b2b" hidden={!altPress}>
                                alt + 1
                              </Tag>
                            </div>
                          </div>
                        }
                        rules={[
                          { required: true, message: `${_t("strIsRequired")}` },
                          { min: 1, message: `${_t("strFrom3-200")}` },
                          { max: 200, message: `${_t("strFrom3-200")}` },
                        ]}
                      >
                        <Input
                          placeholder={_t("strName")}
                          maxLength={200}
                          autoComplete="off"
                          onChange={promptForm}
                          ref={IX_Name}
                          size="small"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="name2"
                        label={_t("strName2")}
                        rules={[
                          {
                            required: false,
                            message: `${_t("strIsRequired")}`,
                          },
                          { min: 1, message: `${_t("strFrom3-200")}` },
                          { max: 200, message: `${_t("strFrom3-200")}` },
                        ]}
                      >
                        <Input
                          placeholder={_t("strName2")}
                          maxLength={200}
                          autoComplete="off"
                          onChange={promptForm}
                          size="small"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="accCatId"
                        rules={[{ required: true }]}
                        label={_t("strAccountCategory")}
                      >
                        <TreeSelect
                          style={{ width: "100%" }}
                          showSearch
                          allowClear
                          onSearch={(value) => {
                            handleAccCat(value);
                          }}
                          filterTreeNode={(search, item) => {
                            return (
                              item.title
                                .toLowerCase()
                                .indexOf(search.toLowerCase()) >= 0
                            );
                          }}
                          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                          treeData={accCatData}
                          placeholder={_t("strAccountCategory")}
                          size="small"
                          treeDefaultExpandAll
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="defCurrencyId"
                        label={_t("strDefaultCurrency")}
                        rules={[{ required: true }]}
                      >
                        <Select
                          allowClear
                          showSearch
                          filterOption={false}
                          onSearch={(value) => {
                            handleCurrActiveSearch(value);
                          }}
                          optionFilterProp="children"
                          notFoundContent={
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
                          }
                          placeholder={_t("strDefaultCurrency")}
                          size="small"
                        >
                          {currOptList}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="defPayMethodId"
                        label={_t("strDefaultPaymentMethod")}
                      >
                        <Select
                          allowClear
                          showSearch
                          filterOption={false}
                          onSearch={(value) => {
                            handlePayMethod(value);
                          }}
                          optionFilterProp="children"
                          notFoundContent={
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
                          }
                          placeholder={_t("strDefaultPaymentMethod")}
                          size="small"
                        >
                          {payMethodOptList}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="defPriceMethodId"
                        label={_t("strDefaultPriceMethod")}
                      >
                        <Select
                          allowClear
                          showSearch
                          filterOption={false}
                          onSearch={(value) => {
                            handlePriceMethod(value);
                          }}
                          optionFilterProp="children"
                          notFoundContent={
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
                          }
                          placeholder={_t("strDefaultPriceMethod")}
                          size="small"
                        >
                          {priceMethodOptList}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="accFinalId"
                        rules={[{ required: true }]}
                        label={_t("strFinalAccount")}
                      >
                        <TreeSelect
                          style={{ width: "100%" }}
                          showSearch
                          allowClear
                          onSearch={(value) => {
                            handleFinalAccSearch(value);
                          }}
                          filterTreeNode={(search, item) => {
                            return (
                              item.title
                                .toLowerCase()
                                .indexOf(search.toLowerCase()) >= 0
                            );
                          }}
                          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                          treeData={finalAccOpt}
                          placeholder={_t("strFinalAccount")}
                          size="small"
                          treeDefaultExpandAll
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="costCenterReqOpt"
                        label={_t("strCostCenter")}
                      >
                        <SelectSingle
                          allowClear={false}
                          defaultValue={0}
                          opt={[
                            {
                              id: 0,
                              name: _t("strUnRequired"),
                              filter1: _t("strUnRequired"),
                            },
                            {
                              id: 1,
                              name: _t("strRequired"),
                              filter1: _t("strRequired"),
                            },
                            {
                              id: 2,
                              name: _t("strDistributionPer"),
                              filter1: _t("strDistributionPer"),
                            },
                          ]}
                          placeholder={_t("strCostCenter")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="note"
                        label={_t("strNote")}
                        rules={[
                          {
                            required: false,
                            message: `${_t("strIsRequired")}`,
                          },
                          { min: 1, message: `${_t("strFrom1-1000")}` },
                          { max: 1000, message: `${_t("strFrom1-1000")}` },
                        ]}
                      >
                        <TextArea
                          placeholder={_t("strNote")}
                          maxLength={1000}
                          autoComplete="off"
                          size="small"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="inactive"
                        valuePropName="checked"
                        label={_t("strInActive")}
                      >
                        <Switch size="small" />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <div className="frFooter">
              <Form.Item>
                <Space size="large">
                  {auth?.perPut && (
                    <div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        size="small"
                        disabled={loading}
                      >
                        {_t("strSave")}
                      </Button>
                      <div
                        style={{
                          opacity: 0.8,
                          zIndex: 99,
                          position: "absolute",
                          top: 24,
                        }}
                      >
                        <Tag color="#2b2b2b" hidden={!altPress}>
                          alt + S
                        </Tag>
                      </div>
                    </div>
                  )}
                  <Dropdown.Button
                    hidden={typeof onNewStore === "function"}
                    overlay={menu}
                    onClick={() => {
                      history.action === "PUSH"
                        ? history.goBack()
                        : history.push("/account");
                    }}
                    size="small"
                  >
                    {" "}
                    {_t("strBack")}
                  </Dropdown.Button>
                  {isGoBack ? (
                    <i />
                  ) : (
                    <RetweetOutlined style={{ fontSize: 21, marginTop: 5 }} />
                  )}
                </Space>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </React.Fragment>
    </div>
  );
};

export default AccountForm;
